import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface DeleteMessagesDialogProps {
  open: boolean;
  count: number;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteMessagesDialog: React.FC<DeleteMessagesDialogProps> = ({
  open,
  count,
  loading = false,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 2 } }}>
    <DialogTitle sx={{ fontSize: '1rem' }}>Delete for everyone?</DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ fontSize: '0.88rem' }}>
        {count === 1
          ? 'This message will be removed for everyone in this community.'
          : `These ${count} messages will be removed for everyone in this community.`}
      </DialogContentText>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
        {loading ? 'Deleting…' : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);
